import { convertLatexToMathMl } from 'mathlive'

const LATEX_DELIMITER_PATTERN = /\$\$([\s\S]+?)\$\$|\$([^$]+)\$|\\\[([\s\S]+?)\\\]|\\\(([\s\S]+?)\\\)/g

export function replaceLatexWithMathMl(text: string): string {
  return text.replace(LATEX_DELIMITER_PATTERN, (match, doubleDollar, singleDollar, bracket, paren) => {
    const latex = doubleDollar ?? singleDollar ?? bracket ?? paren

    if (!latex) {
      return match
    }

    try {
      const mathml = convertLatexToMathMl(latex.trim())
      return `<math>${mathml}</math>`
    } catch {
      return match
    }
  })
}
